<script>
export default {
  name: 'forgetPwd',
  data () {
    return {
      phone: '',
      code: '',
      newPassword: '',
      confirmPassword: '',
      seconds: 60,
      timer: null,
      isSending: false,
      canSubmit: false
    }
  },
  methods: {
    // 验证手机号格式
    validPhone() {
      if (!this.phone) {
        this.$toast('请输入手机号')
        return false
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$toast('请输入正确的手机号')
        return false
      }
      return true
    },
    
    // 发送验证码
    async sendCode() {
      if (!this.validPhone()) {
        return
      }
      
      if (this.isSending) {
        return
      }
      
      this.isSending = true
      
      try {
        // 调用发送验证码接口
        const { data } = await this.$http.get('/api/auth/account/getCodeNoVerify', {
          userphone: this.phone,
          type: 1,
          appCode: 'srm',
        })
        
        this.$toast('验证码已发送，请注意查收')
        
        // 开始倒计时
        this.startCountdown()
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$toast(error.msg || '发送失败，请重试')
        this.isSending = false
      }
    },
    
    // 开始倒计时
    startCountdown() {
      this.seconds = 60
      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--
        } else {
          this.stopCountdown()
        }
      }, 1000)
    },
    
    // 停止倒计时
    stopCountdown() {
      clearInterval(this.timer)
      this.timer = null
      this.isSending = false
      this.seconds = 60
    },
    
    // 验证表单
    validForm() {
      if (!this.validPhone()) {
        return false
      }
      if (!this.code) {
        this.$toast('请输入验证码')
        return false
      }
      if (!this.newPassword) {
        this.$toast('请输入新密码')
        return false
      }
      if (this.newPassword.length < 6) {
        this.$toast('密码长度不能少于6位')
        return false
      }
      if (!this.confirmPassword) {
        this.$toast('请确认密码')
        return false
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$toast('两次输入的密码不一致')
        return false
      }
      return true
    },
    
    // 提交重置密码
    async resetPassword() {
      if (!this.validForm()) {
        return
      }
      
      try {
        // 调用重置密码接口
        this.$http.post('/api/auth/account/changePassword', {
          appCode: 'srm',
          verifyCode: this.code,
          userphone: this.phone,
          password: this.newPassword,
          secondPassword: this.confirmPassword,
        }).then(({ code,msg }) => { 

          if(code == 200) { 
            this.$toast('密码重置成功，请使用新密码登录')
            // 延迟跳转到登录页
            setTimeout(() => {
              this.$router.push('/login')
            }, 1500)
          } else {  
            this.$toast(msg || '重置失败，请重试')
          }
        }) 
      } catch (error) {
        console.error('重置密码失败:', error)
        this.$toast(error.msg || '重置失败，请重试')
      }
    },
    
    // 返回登录页
    goBack() {
      this.$router.push('/login')
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<template>
  <div class="forget-pwd">
    <van-nav-bar title="找回密码" left-arrow @click-left="goBack" />
    
    <div class="container"> 
      <div class="form">
        <!-- 手机号输入 -->
        <div class="form-item">
          <div class="input-wrapper">
            <span class="icon">📱</span>
            <input 
              v-model="phone" 
              class="inp" 
              maxlength="11" 
              placeholder="请输入手机号码" 
              type="text"
            >
          </div>
        </div>

        <!-- 验证码输入 -->
        <div class="form-item">
          <div class="input-wrapper">
            <span class="icon">🔐</span>
            <input 
              v-model="code" 
              class="inp" 
              maxlength="6" 
              placeholder="请输入验证码" 
              type="text"
            >
            <button 
              class="code-btn" 
              :disabled="isSending && seconds > 0"
              @click="sendCode"
            >
              {{ isSending && seconds > 0 ? `${seconds}s` : '获取验证码' }}
            </button>
          </div>
        </div>

        <!-- 新密码输入 -->
        <div class="form-item">
          <div class="input-wrapper">
            <span class="icon">🔒</span>
            <input 
              v-model="newPassword" 
              class="inp" 
              placeholder="请输入新密码（至少6位）" 
              type="password"
            >
          </div>
        </div>

        <!-- 确认密码输入 -->
        <div class="form-item">
          <div class="input-wrapper">
            <span class="icon">🔒</span>
            <input 
              v-model="confirmPassword" 
              class="inp" 
              placeholder="请再次输入新密码" 
              type="password"
            >
          </div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <div @click="resetPassword" class="submit-btn">
        <span>确认重置</span>
      </div> 
    </div>
  </div>
</template>

<style lang="less" scoped>
@primary-color: #ff6b6b;
@primary-gradient: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
@text-primary: #333;
@text-secondary: #888;
@bg-color: #f5f7fa;

// 整体容器优化
.container {
  padding: 40px 24px;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .title {
    margin-bottom: 32px;
    text-align: center;
    
    h3 {
      font-size: 24px;
      font-weight: 600;
      color: @text-primary;
      margin-bottom: 8px;
    }
    
    p {
      line-height: 1.6;
      font-size: 14px;
      color: @text-secondary;
    }
  }

  .form {
    flex: 1;
    
    .form-item {
      margin-bottom: 16px;
      
      .input-wrapper {
        background: #fff;
        border-radius: 12px;
        padding: 3px 12px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        border: 1px solid #eee;
        transition: all 0.3s ease;
        overflow: hidden;
        box-sizing: border-box;
        
        &:focus-within {
          border-color: @primary-color;
          box-shadow: 0 4px 12px rgba(255, 107, 107, 0.15);
        }
        
        .icon {
          font-size: 14px;
          margin-right: 8px;
          opacity: 0.6;
          flex-shrink: 0;
        }
        
        .inp {
          display: block;
          border: none;
          outline: none;
          height: 44px;
          font-size: 14px;
          flex: 1;
          min-width: 0;
          color: @text-primary;
          background: transparent;
          
          &::placeholder {
            color: #bbb;
          }
        }
        
        .code-btn {
          background: @primary-gradient;
          color: #fff;
          border: none;
          border-radius: 4px;
          padding: 5px 8px;
          font-size: 11px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
          flex-shrink: 0;
          max-width: 70px;
          height: 32px;
          line-height: 1;
          box-sizing: border-box;
          
          &:disabled {
            background: #e0e0e0;
            color: #999;
            cursor: not-allowed;
          }
          
          &:not(:disabled):hover {
            opacity: 0.9;
          }
          
          &:not(:disabled):active {
            transform: scale(0.98);
          }
        }
      }
    }
  }

  .submit-btn {
    width: 100%;
    margin-top: 24px;
    background: @primary-gradient;
    color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(255, 107, 107, 0.3);
    font-size: 16px;
    padding: 14px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    
    span {
      position: relative;
      z-index: 1;
      font-weight: 500;
      letter-spacing: 2px;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
    }
  }
  
  .back-login {
    margin-top: 24px;
    text-align: center;
    
    span {
      color: @primary-color;
      cursor: pointer;
      font-size: 14px;
      padding: 8px 16px;
      border-radius: 4px;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 107, 107, 0.1);
        text-decoration: underline;
      }
      
      &:active {
        background: rgba(255, 107, 107, 0.2);
        transform: scale(0.98);
      }
    }
  }
}

// 页面整体背景
.forget-pwd {
  min-height: 100vh;
  background: @bg-color;
  
  :deep(.van-nav-bar) {
    background: @primary-gradient;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.2);
    
    .van-nav-bar__title {
      color: #fff;
      font-weight: 600;
    }
    
    .van-icon {
      color: #fff;
    }
    
    .van-nav-bar__arrow {
      font-size: 18px;
    }
  }
}
</style>


